const initialState = "cash";

export default function myOrderTab(state = initialState, action) {
  switch (action.type) {
    case "SET_MY_ORDER_TAB":
      return action.payload;
    default:
      return state;
  }
}